import type { DatasetDeleteMutatorButtonProps } from "./dataset-delete-mutator-button.type";

import { DeleteOutlined } from "@ant-design/icons";
import { Button } from "antd";

import { useDatasetsMutatorSync } from "@/modules/datasets/datasets-mutator";

const DatasetDeleteMutatorButton = ({
  dataset,
  ...buttonProps
}: DatasetDeleteMutatorButtonProps) => {
  const { addMutatorItem } = useDatasetsMutatorSync();

  const onClick = () => {
    addMutatorItem({
      mutationType: "delete",
      datasetType: dataset.type,
      datasetId: dataset.id,
    });
  };

  return (
    <Button {...buttonProps} icon={<DeleteOutlined />} onClick={onClick} />
  );
};

export default DatasetDeleteMutatorButton;
